export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "scripts/app.Message.worker.d23ef4e1528969f276f7.worker.js");
}
